<template>
    <v-app>
        <div class="mainDiv">
            <div class="FormDiv">
                <div class="contentWrapper">
                    <div class="titleBox">
                        <p class="titleText">歡迎回到OSCE</p>
                    </div>
                    <div class="formBox">
                        <v-card-text>
                            <v-text-field v-model="loginData.username" name="username" label="帳號" type="text"
                                placeholder="帳號" required outlined @keyup.enter="login"></v-text-field>

                            <v-text-field v-model="loginData.password" name="password" label="密碼" type="password"
                                placeholder="密碼" required outlined @keyup.enter="login"></v-text-field>
                        </v-card-text>
                        <v-card-actions class="actionDiv">
                            <v-btn class="actionBtn" color="black" dark @click="login()">登入</v-btn>
                        </v-card-actions>
                    </div>
                </div>
            </div>
            <div class="BackgroundDiv d-none d-sm-flex">
                <lottie :options="lottieOptions" :height="450" :width="450" />
            </div>
        </div>
    </v-app>
</template>

<script>
import authService from "@/services/auth.service";
import Lottie from 'vue-lottie'
import animationData from '@/assets/animation.json'


export default {
    name: "LoginView",
    components: {
        Lottie
    },
    data() {
        return {
            loginData: {
                username: "",
                password: "",
            },
            lottieOptions: {
                animationData: animationData,
                loop: true,
                autoplay: true
            }
        };
    },
    methods: {
        init() {
            if (localStorage.getItem("authenticated")) {
                if (localStorage.getItem("userType") == 0) {
                    this.$router.push("/admin");
                    return;
                } else if (localStorage.getItem("userType") == 1) {
                    this.$router.push("/school");
                    return;
                } else if (localStorage.getItem("userType") == 2) {
                    this.$router.push("/teacher");
                    return;
                } else if (localStorage.getItem("userType") == 3) {
                    this.$router.push("/student");
                    return;
                }
            }
        },
        login() {
            authService
                .login(this.loginData)
                .then((res) => {
                    if (res.code == 0) {
                        if (res.userType == 0) {
                            this.$router.push("/admin");
                            return;
                        } else if (res.userType == 1) {
                            this.$router.push("/school");
                            return;
                        } else if (res.userType == 2) {
                            this.$router.push("/teacher");
                            return;
                        } else if (res.userType == 3) {
                            this.$router.push("/student");
                            return;
                        }
                    }
                })
                .catch((e) => {
                    console.log(e);
                    alert(e.message);
                });
        },
    },
    created() {
        this.init();
    },
};
</script>
<style lang="scss">
@import "https:////fonts.googleapis.com/css?family=Noto+Sans+TC:400,500";

.mainDiv {
    background-color: #f7f8f9;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}

@media screen and (min-width: 768px) {
    .mainDiv {
        flex-direction: row;
    }
    .FormDiv {
        background-color: #f7f8f9;
        width: 60%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .BackgroundDiv {
        background-color: #f7f8f9;
        width: 40%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-right: 10vw;
    }
}

@media screen and (max-width: 768px) {
    .mainDiv {
        flex-direction: column;
        padding-top: 224px;
    }
    .FormDiv {
        background-color: #f7f8f9;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin-bottom: 24px;
    }
    .BackgroundDiv {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
}

.image {
    width: 100%;
    height: 100%;
}

.titleBox {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.formBox {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
}

.titleText {
    color: #000;
    font-family: "Noto Sans CJK TC";
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.titleIcon {
    margin: 40px auto;
}

.actionBtn {
    width: 50%;
    margin: 5px;

}

.actionDiv {
    place-content: center;
}

.contentWrapper {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    width: 80%;
    max-width: 400px;
}
</style>